(function () {
  if (window.__gpInit) return;
  window.__gpInit = true;

  /* Lieferdatum: +1 bis +3 Werktage */
  function eta() {
    var el = document.querySelector('[data-gp-eta]');
    if (!el) return;
    var days = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    function add(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
    var now = new Date();
    el.textContent = 'Lieferung ' + fmt(add(now, 1)) + ' – ' + fmt(add(now, 3));
  }

  /* Mitlaufende Kaufleiste (Handy) */
  function sticky() {
    var bar = document.querySelector('[data-gp-sticky]');
    if (!bar) return;
    var target = document.getElementById(bar.dataset.target);
    if (!target) return;
    document.body.appendChild(bar);
    bar.hidden = false;
    bar.querySelector('[data-gp-sticky-btn]').addEventListener('click', function () { target.click(); });
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', !e.isIntersecting && below);
    });
    io.observe(target);
  }

  function start() { eta(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
